"use client";

import { useState, useEffect } from "react";
import { Menu, X, Facebook, Phone, Mail, MessageSquare, Instagram, Twitter, Youtube, Smartphone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        {[1, 2, 3, 4, 5].map(i => <div key={i} className="h-4 w-16 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden lg:flex">
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-bold uppercase tracking-wider text-primary hover:text-secondary transition-colors">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems
  } = useMenu();
  return <nav className="flex flex-col gap-4 mt-8">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-lg font-semibold text-primary hover:text-secondary border-b border-muted pb-2">
          {item.label}
        </Link>)}
      <div className="mt-4 flex flex-col gap-2 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <Phone className="size-4" /> 323-492-6292
        </div>
        <div className="flex items-center gap-2">
          <Mail className="size-4" /> phoenixenerprises@gmail.com
        </div>
      </div>
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300">
      {}
      <div className="bg-primary text-white py-2 hidden md:block">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <Link to="tel:3234926292" className="hover:text-secondary transition-colors">
              <Phone className="size-4" />
            </Link>
            <Link to="sms:3234926292" className="hover:text-secondary transition-colors">
              <Smartphone className="size-4" />
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <Link to="#" className="hover:text-secondary transition-colors"><Facebook className="size-4" /></Link>
            <Link to="#" className="hover:text-secondary transition-colors"><Twitter className="size-4" /></Link>
            <Link to="#" className="hover:text-secondary transition-colors"><Youtube className="size-4" /></Link>
            <Link to="#" className="hover:text-secondary transition-colors"><Instagram className="size-4" /></Link>
          </div>
        </div>
      </div>

      {}
      <div className={`bg-white border-b border-muted transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'}`}>
        <div className="container mx-auto px-4 flex items-center justify-between">
          <Link to="/" className="flex-shrink-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/phoenix_enterprise_tcp_logo.png" className="h-12 md:h-16 w-auto object-contain" alt="PHOENIX ENTERPRISE TCP" />
          </Link>

          <div className="hidden md:flex flex-col items-end gap-1">
            <Link to="mailto:phoenixenerprises@gmail.com" className="text-primary font-bold hover:text-secondary transition-colors">
              phoenixenerprises@gmail.com
            </Link>
            <div className="flex gap-6 text-lg font-black text-foreground">
              <div className="flex items-center gap-2">
                <span className="text-sm font-normal text-muted-foreground">Call:</span>
                <Link to="tel:3234926292">323-492-6292</Link>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-normal text-muted-foreground">Text:</span>
                <Link to="sms:3234926292">323-492-6292</Link>
              </div>
            </div>
          </div>

          {}
          <div className="md:hidden">
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="text-primary">
                  <Menu className="size-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px]">
                <SheetHeader>
                  <SheetTitle className="text-left">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/phoenix_enterprise_tcp_logo.png" className="h-10 w-auto" alt="PHOENIX ENTERPRISE TCP" />
                  </SheetTitle>
                </SheetHeader>
                <MenuProvider menu_id="45">
                  <MobileMenuConsumer />
                </MenuProvider>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>

      {}
      <div className="bg-white border-b border-muted hidden md:block">
        <div className="container mx-auto px-4 flex items-center justify-between py-3">
          <MenuProvider menu_id="45">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>
      </div>
    </header>;
}